export enum Tarifart {
    Normal = 'N',
    Halb = 'H',
    Individuell = 'I',
    KeineVerrechnung = 'K',
    Spaeter = 'S',
    Rabatt5 = '5',
    Rabatt10 = '1',
    Rabatt15 = 'f',
    Rabatt20 = '2',
    Rabatt30 = '3',
}
